import { ScreenMode } from 'apiConnector/quote-loading';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface IQuoteCancelApi {
  cancelQuote(cancelRequest: QuoteCancelRequest): Observable<void>;
}
export interface QuoteCancelRequest {
  negotiationId?: string;
  quoteId?: string;
  productSubtype?: string;
  productType?: string;
  screenMode?: ScreenMode;
}
export type IQuoteApi = IQuoteCancelApi;

export function quoteApiConnector(http$: IHttpClient): IQuoteApi {
  return {
    cancelQuote(cancelRequest: QuoteCancelRequest): Observable<void> {
      return http$
        .post({
          url: `api/v1/quote/cancel`,
          body: cancelRequest,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
